import { render } from "./NameNsDescription.vue?vue&type=template&id=1747c55b&scoped=true"
import script from "./NameNsDescription.vue?vue&type=script&lang=js"
export * from "./NameNsDescription.vue?vue&type=script&lang=js"

import "./NameNsDescription.vue?vue&type=style&index=0&id=1747c55b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1747c55b"]])

export default __exports__